/* eslint-disable import/no-named-as-default */
import React from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import * as workOrderActions from 'actions/workOrderActions';
import * as justAskActions from 'actions/justAskActions';
import * as siteActions from 'actions/siteActions';
import * as sqcActions from 'actions/sqcActions';
import * as chargeActions from 'actions/chargeActions';
import * as techInventoryActions from 'actions/techInventoryActions';
import WorkOrderDetails from 'workOrderComponents/WorkOrderDetail';
import {SLIDE_CONFIG} from 'constants/panelConfig';
import Footer from 'containers/Footer';
import Immutable from 'immutable';
import * as mouseFlowUtils from '../../utils/mouseFlowUtils';
import { TAG_WORK_ORDER_DETAILS_PAGE } from '../../constants/mouseFlow';
import {SET_ACTIVELY_SELECTED_WORK_ORDER_ID} from "../../constants/actionTypes";

export class WorkOrderDetailPage extends React.Component {

    constructor(props, context) {
        super(props, context);
        this.clearOrderDetail = this
            .clearOrderDetail
            .bind(this);

        const {match} = props;
        mouseFlowUtils.setOrderId(match.params.workOrderId);
        mouseFlowUtils.setTag(TAG_WORK_ORDER_DETAILS_PAGE);
    }

  componentWillMount() {
    const {workOrderActions, uiStateActions, match} = this.props;

    [
      uiStateActions.setActivelySelectedWorkOrderId,
      workOrderActions.workOrderDetailPageOpened,
      workOrderActions.getHomeVerifyStarted
    ].forEach((fn) => {
      fn(match.params.workOrderId);
    }, this);

    window.scrollTo(0, 0);
  }

    componentDidMount() {
        const {techData, techInventoryActions} = this.props;
        const userId = this.getOrderUserId();
        const inventoryLoading = techData.getIn(['techs', userId, 'inventory', 'loading']);
        const inventoryLoadingFinished = techData.getIn(['techs', userId, 'inventory', 'loadingFinished']);

        const shouldLoad = !inventoryLoading && !inventoryLoadingFinished;

        if (userId && shouldLoad) {

            techInventoryActions.getTechInventoryStarted({
                isSelf: false
            }, userId);
        }
    }

    componentWillReceiveProps(nextProps) {
        const {workOrderActions, workOrder, match} = nextProps;

        const orderId = match.params.workOrderId;

        const slideIndex = workOrder.getIn(['workOrderDetails', orderId, 'slideIndex']);

        if (!slideIndex && orderId) {
            workOrderActions.setSlideIndex(0, orderId);
        }
    }

    clearOrderDetail() {
        const {workOrderActions, match, workOrder} = this.props;
        const orderId = match.params.workOrderId;
        const slideIndex = workOrder.getIn(['workOrderDetails', orderId, 'slideIndex']);
        const slideConfig = SLIDE_CONFIG[slideIndex];

        slideConfig
            .detailKey
            .forEach((detailKey) => {
                workOrderActions.clearWorkOrderDetail(orderId, detailKey);
            });

    }

    getOrderUserId() {
        const {techData, match, workOrder} = this.props;
        let orderUserId;
        const serviceOrderStatus = workOrder.getIn(['workOrderDetails', match.params.workOrderId, 'orderStatus', 'details', 'serviceOrderStatus']);
        if(serviceOrderStatus == null) {
            return;
        }
        const orderTechId = serviceOrderStatus.first().get('techId');
        const techIt = techData.get('techs').keys();
        let res = techIt.next();
        while(!res.done){
            if(techData.getIn(['techs', res.value, 'info', 'techId']) === orderTechId){
                orderUserId = res.value;
                break;
            }
            res = techIt.next();
        }
        return orderUserId;
    }

    render() {

        const {
            workOrder,
            match,
            workOrderActions,
            site,
            chargeActions,
            user,
            justAskActions,
            techData,
            sqcActions,
            techInventoryActions
        } = this.props;
        const orderId = match.params.workOrderId;

        if (!workOrder) {
            return null;
        }
        const orderDetail = workOrder.getIn(['workOrderDetails', orderId]);

        if (!orderDetail) {
            return null;
        }

        const schedulingSystemDetails = orderDetail.getIn(['schedulingSystemDetails', 'details']);

        if (!schedulingSystemDetails) {
            return null;
        }

        let inventoryList = new Immutable.List();

        techData
            .get('techs')
            .forEach((tech) => {

                const inventory = tech.getIn(['inventory', 'details']);

                if (inventory && schedulingSystemDetails) {
                    inventory.forEach((inventoryItem) => {

                        if (inventoryItem.get('techId').trim() === schedulingSystemDetails.getIn(['technicianId'])) {
                            inventoryList = inventoryList.push(inventoryItem);
                        }

                    });

                }

            });

        const groupedEquipment = inventoryList.groupBy((item) => {
            return item
                .get('serialNumber')
                .trim();
        }).toList();

        const reducedTechEquipment = groupedEquipment.map((item) => {

            const portTypes = item.map((equipment) => {

                return equipment.get('portType');

            });

            const firstItem = item
                .first()
                .set('portTypes', portTypes);

            return firstItem;
        });

        const orderUserId = this.getOrderUserId();

        return (
            <div>
                <Footer/>
                <WorkOrderDetails
                    sqcActions={sqcActions}
                    techInventoryLoading={techData.getIn([
                        'techs', user.get('userId'),
                        'inventory',
                        'loading'
                    ])}
                    techInventory={reducedTechEquipment}
                    techInventoryActions={techInventoryActions}
                    site={site}
                    orderDetail={orderDetail}
                    chargeActions={chargeActions}
                    user={user}
                    justAskActions={justAskActions}
                    workOrderActions={workOrderActions}
                    orderId={orderId}
                    techId={techData.getIn([
                        'techs',
                        user.get('userId'),
                        'info',
                        'techId'
                    ])}
                    orderUserId={orderUserId}
                />
            </div>
        );
    }
}

WorkOrderDetailPage.propTypes = {
    workOrderActions: PropTypes.object.isRequired,
    sqcActions: PropTypes.object.isRequired,
    techInventoryActions: PropTypes.object.isRequired,
    chargeActions: PropTypes.object.isRequired,
    workOrder: PropTypes.object.isRequired,
    site: PropTypes.object,
    match: PropTypes.object,
    user: PropTypes.object,
    justAskActions: PropTypes.object,
    techData: PropTypes.object,
    uiStateActions: PropTypes.object
};

function mapStateToProps(state) {
    return {
        workOrder: state.get('workOrder'),
        site: state.get('site'),
        user: state.get('user'),
        techData: state.get('techData')
    };
}

function mapDispatchToProps(dispatch) {
    return {
        workOrderActions: bindActionCreators(workOrderActions, dispatch),
        siteActions: bindActionCreators(siteActions, dispatch),
        sqcActions: bindActionCreators(sqcActions, dispatch),
        chargeActions: bindActionCreators(chargeActions, dispatch),
        justAskActions: bindActionCreators(justAskActions, dispatch),
        techInventoryActions: bindActionCreators(techInventoryActions, dispatch),
        uiStateActions: bindActionCreators({
          setActivelySelectedWorkOrderId: (workOrderId) => ({ type: SET_ACTIVELY_SELECTED_WORK_ORDER_ID, workOrderId: workOrderId })
        }, dispatch)
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(WorkOrderDetailPage);



// WEBPACK FOOTER //
// ./src/containers/pages/WorkOrderDetailPage.js